import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios, { cookies } from "../../axios/axios";
import { ToastContainer, toast } from "react-toastify";
import Navbar from "../../Components/Navbar";
import Footer from "../../Components/Footer";

const UserDetailAdmin = () => {
  const [user, setUser] = useState({});
  const [role, setRole] = useState("user");
  const [billing, setBilling] = useState("order-wise");

  const { id } = useParams();
  const navigate = useNavigate();

  const getUserById = async () => {
    try {
      const response = await axios.get(`/user/getUserById/${id}`);
      setUser(response.data);
      setRole(response.data.role);
      setBilling(response.data.billingType || "order-wise");
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  useEffect(() => {
    if (id) getUserById();
  }, [id]);

  const updateUserRole = async () => {
    try {
      const response = await axios.put(`/user/updateUserRole/${id}`, { role });
      if (response.status === 200) {
        navigate("/user-table");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  const updateBillingType = async () => {
    try {
      const response = await axios.patch(`/user/${id}/billing`, {
        billingType: billing,
      });
      if (response.status === 200) {
        alert("Billing  type updated!");
        navigate("/user-table");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4">
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <div className="row">
          <div className="col-md-6">
            <h3>User Detail</h3>
            <table className="table table-hover">
              <tbody>
                <tr>
                  <td>Id :</td>
                  <td>{user.id}</td>
                </tr>
                <tr>
                  <td>Name :</td>
                  <td>{user.fname}</td>
                </tr>{" "}
                <tr>
                  <td>Email :</td>
                  <td>{user.email}</td>
                </tr>{" "}
                <tr>
                  <td>Studio Name:</td>
                  <td>{user.studio_name}</td>
                </tr>{" "}
                <tr>
                  <td>Website Link :</td>
                  <td>{user.website_link}</td>
                </tr>{" "}
                <tr>
                  <td>Joined On :</td>
                  <td>{new Date(user.createdAt).toLocaleDateString()}</td>
                </tr>
                <tr>
                  <td>Role</td>
                  <td>
                    <select
                      className="form-select"
                      value={role}
                      onChange={(e) => setRole(e.target.value)}
                    >
                      <option value="user">User</option>
                      <option value="editor">Editor</option>
                      <option value="manager">Manager</option>
                    </select>
                  </td>
                  <button
                    onClick={updateUserRole}
                    className="btn text-light bg_maincolor mt-3"
                  >
                    Update Role
                  </button>
                </tr>{" "}
                <tr>
                  <td>Billing Type</td>
                  <td>
                    <select
                      className="form-select"
                      value={billing}
                      onChange={(e) => setBilling(e.target.value)}
                    >
                      <option value="order-wise">Order Wise</option>
                      <option value="monthly">Monthly</option>
                    </select>
                  </td>
                  <button
                    onClick={updateBillingType}
                    className="btn text-light bg_maincolor mt-3"
                  >
                    Update Billing type
                  </button>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default UserDetailAdmin;
